<template>
    <div id="map">
    </div>
</template>

<script>
import mapboxgl from "mapbox-gl";
require('../../node_modules/mapbox-gl/dist/mapbox-gl.css');
export default {
  components: {
  },
  props: ["travelOptionDetailActive"],
  data() {
    return {
      accessToken: "pk.eyJ1Ijoic3ZlbjRhbGwiLCJhIjoiY2swb3pmaGl5MGVzNTNsczM1Z2loMmxkayJ9.z6nzNgRWrcRqDHIwO2MbkA", // your access token. Needed if you using Mapbox maps
      mapStyle: "mapbox://styles/hansie/ck1w3hz681gs41ctf9qg0jtgv" // your map style
    };
  },

  mounted() {
    this.createMap();
    console.log("test");
  },
  updated() {
    //this.map.resize();
  },
  methods: {
    createMap: function() {
      mapboxgl.accessToken = 'pk.eyJ1Ijoic3ZlbjRhbGwiLCJhIjoiY2swb3pmaGl5MGVzNTNsczM1Z2loMmxkayJ9.z6nzNgRWrcRqDHIwO2MbkA';
      this.map = new mapboxgl.Map({
        container: 'map', // container id
        style: 'mapbox://styles/hansie/ck1w3hz681gs41ctf9qg0jtgv', // stylesheet location
        center: [5.1, 52.2], // starting position [lng, lat]
        zoom: 7 // starting zoom
      });
    },

  },

  
};

</script>
<style scoped>
#map {
    height: 100%;
    display: inline-block;
    vertical-align: top;
    overflow: hidden;
    flex-grow: 1;
}
</style>
//   width: calc(100% - 400px);